// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-detail-bottom-sheet {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
  padding: 0 20px 0 20px;
}

/* Header Section */
.active-detail-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-light-gray);
}

.back-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
  margin-top: 4px;
}

.back-button:hover {
  background-color: var(--color-light-gray);
}

.header-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.active-name {
  margin: 0;
  color: var(--color-black);
}

.header-tags {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.level-tag {
  padding: 4px 12px;
  border-radius: 16px;
  min-width: 70px;
  text-align: center;
}

.level-text {
  color: var(--text-on-accent) !important;
  font-weight: 600;
  margin: 0;
}

/* Content Sections */
.active-detail-content {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 0;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-title {
  margin: 0;
  color: var(--color-black);
  font-weight: 600;
}

.section-content {
  margin: 0;
  color: var(--color-dark-gray);
  line-height: 1.6;
}

/* Usage Information Grid */
.usage-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.usage-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: var(--color-light-gray);
  border-radius: 8px;
}

.usage-item .typography:first-child {
  color: var(--color-black);
  font-weight: 600;
}

.usage-item .typography:last-child {
  color: var(--color-dark-gray);
}

/* Compatibility Grid */
.compatibility-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.compatibility-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background: var(--color-light-gray);
  border-radius: 8px;
}

.compatibility-item .typography:first-child {
  color: var(--color-black);
  font-weight: 600;
}

.compatibility-item .typography:last-child {
  color: var(--color-dark-gray);
}

/* Owned Products Section */
.owned-products-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.owned-product-item {
  width: 100%;
}

.compact-product-card {
  height: auto;
  min-height: 100px;
}

.compact-product-card .product-card-content {
  padding: 10px;
}

.compact-product-card .product-card-image {
  width: 50px;
  height: 50px;
}

.compact-product-card .product-card-info {
  gap: 4px;
}

.compact-product-card .product-card-name {
  font-size: 14px;
  line-height: 1.4;
}

.compact-product-card .product-card-brand {
  font-size: 12px;
}

/* Combinability Section */
.combinability-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background: var(--color-light-gray);
  border-radius: 8px;
  margin-bottom: 12px;
}

.combinability-item:last-child {
  margin-bottom: 0;
}

.combinability-item .typography:first-child {
  color: var(--color-black);
  font-weight: 600;
}

.combinability-item .typography:last-child {
  color: var(--color-dark-gray);
}

/* Loading and Error States */
.loading-state,
.error-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.error-state {
  color: var(--color-warning-red);
}

.error-text {
  color: var(--color-warning-red) !important;
}

/* Experience Level Section */
.experience-level-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}

.level-chips {
  display: flex;
  gap: 8px;
}

.level-chip {
  flex: 1;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--color-light-gray);
}

.cancel-button,
.save-button {
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;
}

.cancel-button {
  background-color: var(--color-white);
  border-color: var(--color-gray);
  color: var(--color-dark-gray);
}

.cancel-button:hover:not(:disabled) {
  background-color: var(--color-light-gray);
}

.cancel-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.save-button {
  background-color: var(--accent);
  border-color: var(--accent);
  color: var(--text-on-accent);
}

.save-button:hover:not(:disabled) {
  background-color: var(--color-primary-dark);
  border-color: var(--color-primary-dark);
}

.save-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: var(--color-gray);
  border-color: var(--color-gray);
}

/* Custom scrollbar for the content */
.active-detail-content::-webkit-scrollbar {
  width: 4px;
}

.active-detail-content::-webkit-scrollbar-track {
  background: var(--color-light-gray);
  border-radius: 2px;
}

.active-detail-content::-webkit-scrollbar-thumb {
  background: var(--color-gray);
  border-radius: 2px;
}

.active-detail-content::-webkit-scrollbar-thumb:hover {
  background: var(--color-dark-gray);
}

`, "",{"version":3,"sources":["webpack://./src/bottomdrawers/ActiveDetailBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".active-detail-bottom-sheet {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  gap: 20px;\n  padding: 0 20px 0 20px;\n}\n\n/* Header Section */\n.active-detail-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--color-light-gray);\n}\n\n.back-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n.back-button:hover {\n  background-color: var(--color-light-gray);\n}\n\n.header-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.active-name {\n  margin: 0;\n  color: var(--color-black);\n}\n\n.header-tags {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.level-tag {\n  padding: 4px 12px;\n  border-radius: 16px;\n  min-width: 70px;\n  text-align: center;\n}\n\n.level-text {\n  color: var(--text-on-accent) !important;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* Content Sections */\n.active-detail-content {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-height: 0;\n}\n\n.detail-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.section-title {\n  margin: 0;\n  color: var(--color-black);\n  font-weight: 600;\n}\n\n.section-content {\n  margin: 0;\n  color: var(--color-dark-gray);\n  line-height: 1.6;\n}\n\n/* Usage Information Grid */\n.usage-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n.usage-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n  background: var(--color-light-gray);\n  border-radius: 8px;\n}\n\n.usage-item .typography:first-child {\n  color: var(--color-black);\n  font-weight: 600;\n}\n\n.usage-item .typography:last-child {\n  color: var(--color-dark-gray);\n}\n\n/* Compatibility Grid */\n.compatibility-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.compatibility-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px;\n  background: var(--color-light-gray);\n  border-radius: 8px;\n}\n\n.compatibility-item .typography:first-child {\n  color: var(--color-black);\n  font-weight: 600;\n}\n\n.compatibility-item .typography:last-child {\n  color: var(--color-dark-gray);\n}\n\n/* Owned Products Section */\n.owned-products-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.owned-product-item {\n  width: 100%;\n}\n\n.compact-product-card {\n  height: auto;\n  min-height: 100px;\n}\n\n.compact-product-card .product-card-content {\n  padding: 10px;\n}\n\n.compact-product-card .product-card-image {\n  width: 50px;\n  height: 50px;\n}\n\n.compact-product-card .product-card-info {\n  gap: 4px;\n}\n\n.compact-product-card .product-card-name {\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.compact-product-card .product-card-brand {\n  font-size: 12px;\n}\n\n/* Combinability Section */\n.combinability-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px;\n  background: var(--color-light-gray);\n  border-radius: 8px;\n  margin-bottom: 12px;\n}\n\n.combinability-item:last-child {\n  margin-bottom: 0;\n}\n\n.combinability-item .typography:first-child {\n  color: var(--color-black);\n  font-weight: 600;\n}\n\n.combinability-item .typography:last-child {\n  color: var(--color-dark-gray);\n}\n\n/* Loading and Error States */\n.loading-state,\n.error-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.error-state {\n  color: var(--color-warning-red);\n}\n\n.error-text {\n  color: var(--color-warning-red) !important;\n}\n\n/* Experience Level Section */\n.experience-level-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.level-chips {\n  display: flex;\n  gap: 8px;\n}\n\n.level-chip {\n  flex: 1;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid var(--color-light-gray);\n}\n\n.cancel-button,\n.save-button {\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid;\n}\n\n.cancel-button {\n  background-color: var(--color-white);\n  border-color: var(--color-gray);\n  color: var(--color-dark-gray);\n}\n\n.cancel-button:hover:not(:disabled) {\n  background-color: var(--color-light-gray);\n}\n\n.cancel-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.save-button {\n  background-color: var(--accent);\n  border-color: var(--accent);\n  color: var(--text-on-accent);\n}\n\n.save-button:hover:not(:disabled) {\n  background-color: var(--color-primary-dark);\n  border-color: var(--color-primary-dark);\n}\n\n.save-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: var(--color-gray);\n  border-color: var(--color-gray);\n}\n\n/* Custom scrollbar for the content */\n.active-detail-content::-webkit-scrollbar {\n  width: 4px;\n}\n\n.active-detail-content::-webkit-scrollbar-track {\n  background: var(--color-light-gray);\n  border-radius: 2px;\n}\n\n.active-detail-content::-webkit-scrollbar-thumb {\n  background: var(--color-gray);\n  border-radius: 2px;\n}\n\n.active-detail-content::-webkit-scrollbar-thumb:hover {\n  background: var(--color-dark-gray);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
